import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage, tr } from "../i18n";
import { lp } from "../components/Navbar";
import { PageHero, CTABand } from "./Shared";
import { Stagger, StaggerItem } from "../components/motion";
import { Badge } from "../components/portal";
import { STANDARDS } from "../data/standards";
export default function Standards() {
  const {
    lang
  } = useLanguage();
  return <div data-testid="standards-page">
      <PageHero kicker={tr("ESAIA Standards")} title={tr("A structured framework for responsible AI assurance.")} copy={tr("ESAIA develops structured standards and assessment methodologies designed to help organizations evaluate the ethical, operational and governance dimensions of artificial intelligence. All active ESAIA standards are listed below and can be opened and downloaded.")} />

      <section className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
        <Stagger className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {STANDARDS.map(s => <StaggerItem key={s.slug} className="h-full">
              <Link to={lp(lang, `/standards/${s.slug}`)} data-testid={`standard-card-${s.slug}`} className="group flex h-full flex-col border border-esaia-line bg-white p-8 transition-all duration-300 hover:border-esaia-blue/50 hover:shadow-md sm:p-10">
                <div className="flex items-center justify-between">
                  <Badge tone="green">{tr(s.status)}</Badge>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-esaia-subtle">{tr("Version")}{" "}{s.version}
                  </span>
                </div>
                <h2 className="mt-7 font-serif text-3xl font-light tracking-tight text-esaia-ink transition-colors group-hover:text-esaia-blue sm:text-4xl">
                  {s.code}
                </h2>
                <p className="mt-2 text-base font-medium text-esaia-ink">{tr(s.title)}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-esaia-muted">{tr(s.purpose)}</p>
                <div className="mt-7 flex items-center justify-between border-t border-esaia-line pt-5">
                  <span className="font-mono text-[11px] tracking-widest text-esaia-subtle">{tr("Issued ·")}{" "}{tr(s.issued)}
                  </span>
                  <span className="inline-flex items-center gap-2 text-sm font-semibold text-esaia-blue">{tr("View standard")}{" "}<ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </StaggerItem>)}
        </Stagger>
        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-esaia-subtle" data-testid="standards-note">{tr("ESAIA standards are voluntary and independent. Alignment with an ESAIA standard supports responsible AI practice; it does not by itself constitute legal compliance with the EU AI Act or any other legislation.")}{" "}</p>
      </section>

      <CTABand title={tr("Assess your organization against the ESAIA framework.")} copy={tr("Start with the free ERI for an initial readiness picture, or request a full certification assessment.")} primary={{
      to: "/eri",
      label: tr("Take the Free ERI")
    }} secondary={{
      to: "/contact",
      label: tr("Request a Quote")
    }} />
    </div>;
}
